import { ServiceResult } from '../models/api-shared.models';
import { ProductShoppingCategory } from '../models/product-shopping-category.models';
import ApiService from './api-service';

class ProductShoppingCategoryService extends ApiService {
  private static classInstance: ProductShoppingCategoryService;

  private constructor() {
    super('ProductShoppingCategory');
  }

  /**
   * Returns all product shopping categories in a flat list,
   * including level and sequence metadata.
   */
  public getProductShoppingCategories(customerId: string): ServiceResult<ProductShoppingCategory[]> {
    return this.get(`${this.baseUrl}/GetProductShoppingCategories?CustomerId=${customerId}`);
  }

  public static getInstance(): ProductShoppingCategoryService {
    if (!this.classInstance) {
      this.classInstance = new ProductShoppingCategoryService();
    }
    return this.classInstance;
  }
}

export default ProductShoppingCategoryService;
